import { useEffect } from "react";
import { getIntegratedExchanges } from "../../redux/exchange/actions";
import { useDispatch, useSelector } from "react-redux";

function UseFetchIntegratedExchanges() {
  const {
    exchangeState: {
      integratedDataLoading,
      getIntegratedList,
      integratedDataError,
    },
    main: { userData },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      userData?.email &&
      !integratedDataLoading &&
      !getIntegratedList &&
      !integratedDataError
    ) {
      dispatch(
        getIntegratedExchanges(
          userData?.["custom:custom_username"],
          userData?.["cognito:username"],
        ),
      );
    }
  }, [
    dispatch,
    integratedDataLoading,
    userData?.email,
    getIntegratedList,
    integratedDataError,
    userData,
  ]);

  return null;
}

export default UseFetchIntegratedExchanges;
